import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['toggleButton'];
  static values = {
    showLabel: { type: String, default: 'Show all' },
    hideLabel: { type: String, default: 'Hide all' },
    expanded: { type: Boolean, default: true },
  };

  connect() {
    this.updateButtonLabel();
  }

  toggleAll() {
    this.expandedValue = !this.expandedValue;

    const eventName = this.expandedValue ? 'accordion:expand' : 'accordion:collapse';
    const sections = this.element.querySelectorAll('[data-controller~="accordion"]');

    sections.forEach((section) => {
      section.dispatchEvent(new CustomEvent(eventName, { bubbles: false }));
    });

    this.updateButtonLabel();
  }

  updateButtonLabel() {
    if (!this.hasToggleButtonTarget) return;

    this.toggleButtonTarget.textContent = this.expandedValue
      ? this.hideLabelValue
      : this.showLabelValue;
  }
}
